import { getAPIWaitingTime } from 'helper/API_callingTimer.js';
import simulateCodes from 'constants/simulateCodes';
import { digitsConverter } from '../../../helper/digitsHelper.js';

export var confirmPaymentMixin = {
  methods: {
    moveToFailurePage(operationStatusCode) {
      this.setOTPDetails({
        component: 'OTPFailure',
        step: 3,
        operationStatusCode,
      });
    },
    showErrorMessage(msg) {
      this.error = msg;
      this.showError = true;
    },
    moveToSuccessPage() {
      this.setOTPDetails({ component: 'OTPSuccess', step: 3 });
    },

    async confirmPayment() {
      this.loading = true;
      this.isPinCodeDisabled = true;
      this.showError = false;
      this.showSuccess = false;

      this.pinCode = digitsConverter(this.pinCode);

      try {
        let response = await this.$http.post(`/otp/ConfirmPaymentTransaction`, {
          TransactionId: this.OTPDetails.otpDictionary.transactionId,
          PinCode: this.pinCode,
          Simulate: process.env.NODE_ENV === 'development' ? true : false,
          SimulateStatusCode: simulateCodes.failed, // ['pending' , 'failed' , 'success']
        });
        /*========= response object Template ========== */
        // let response = {
        //   data: {
        //     transactionId: null,
        //     verificationMethod: 0,
        //     verificationInstruction: null,
        //     statusCode: 3,
        //     responseCode: 11,
        //   },
        // };
        /*============================================= */

        // success
        if (response.data.statusCode === 1) {
          if (response.data.responseCode === 0) {
            this.moveToSuccessPage();
          } else {
            this.moveToFailurePage(response.data.responseCode);
          }
        } else if (response.data.statusCode === 0) {
          this.moveToFailurePage(response.data.responseCode);
        } else if (response.data.statusCode === 2) {
          // get first call starting time
          if (this.startingTime == 0) {
            this.startingTime = new Date().getTime();
          }

          // time out after 15 mins
          setTimeout(() => {
            clearInterval(this.API_Timeout);
            this.moveToFailurePage(19); //19 TIMEOUT_CODE
            this.loading = false;
            this.isPinCodeDisabled = false;
          }, 1000 * 60 * 15);

          this.showPendingMsg = true;
          this.API_Timeout = setTimeout(() => {
            this.confirmPayment();
          }, getAPIWaitingTime(this.startingTime, new Date().getTime()));
        } else if (response.data.statusCode === 3) {
          if (response.data.responseCode === 11) {
            this.invalidPinCodeCount += 1;
            if (this.invalidPinCodeCount >= 5) {
              this.moveToFailurePage(response.data.responseCode);
            }
          }
          this.showErrorMessage(
            this.$translate('RESPONSECODE_' + response.data.responseCode)
          );
          this.loading = false;
          this.isPinCodeDisabled = false;
        }
      } catch (error) {
        this.showErrorMessage(this.$translate('GENERALERRORMESSAGE'));
      } finally {
        this.loading = false;
        this.isPinCodeDisabled = false;
      }
    },
  },
};
